module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 45
// module chunks = 0